<!-- will separate this out later -->
<div class="whatPeopleSay bg-dmp-green">
  <div class="whatPeopleSay__container mx-auto max-w-4xl h-56 desktop:h-32 p-4 mb-16">
    <div class="whatPeopleSay__content flex desktop:gap-5 desktop:items-center relative pt-10">
      <div class="img__container">
        <div class="img_container absolute left-1/2 -translate-x-1/2 w-32 h-32 z-50 desktop:relative"><img src="https://cdn.badlandsranch.com/images/woman-dog.png" alt="woman dog"></div>
      </div>
      <div class="right_content w-full rounded-3xl items-center justify-between flex flex-col bg-white p-4 py-8 gap-4 relative top-[100px] desktop:top-0 desktop:flex-row">
        <div class="text-badlands-green font-bold text-2xl desktop:text-3xl">What people are saying…</div>
        <img src="https://cdn.badlandsranch.com/images/title-icons-social.png" alt="socials">
      </div>
    </div>
  </div>
</div>

<div class="upsell-slider mt-16">
  <div class="upsell-slider__container mx-auto p-4 text-xl mb-8">
    <div class="relative w-full " #sliderContainer>
      <!-- Navigation Arrows -->
      <div class="absolute top-10 left-0 right-0 z-10">
        <button
          class="absolute top-1/2 -translate-y-1/2 left-2.5 rounded-full w-10 h-10 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 disabled:opacity-30 disabled:cursor-not-allowed desktop:-left-10"
          (click)="goPrevious()"
          [innerHTML]="leftArrowContent">
        </button>

        <button
          class="absolute top-1/2 -translate-y-1/2 right-2.5 rounded-full w-10 h-10 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110 disabled:opacity-30 disabled:cursor-not-allowed desktop:-right-10"
          (click)="goNext()"
          [innerHTML]="rightArrowContent">
        </button>
      </div>

      <!-- Slides Container -->
      <div class="upsell-slides__slide relative w-full overflow-hidden">
        <div
          class="flex transition-transform ease-in-out will-change-transform"
          #slidesWrapper
          [style.transition-duration]="options.speed + 'ms'">
          @for (slide of slides; track $index; let i = $index) {
            <div
              class="flex-shrink-0 box-border"
              [style.width.%]="100 / (options.slidesPerView || 1)"
              [style.padding-right.px]="i < slides.length - 1 ? options.spaceBetween : 0">
              <ng-container [ngTemplateOutlet]="slideTemplate" [ngTemplateOutletContext]="{ $implicit: slide, index: i }"></ng-container>
            </div>
          }
        </div>
      </div>

      <!-- Social media interaction images positioned outside overflow containers -->
      @if (slides[currentSlide]?.via) {
        <img class="absolute left-[36px] mb-[-30px] desktop:left-[190px] z-50" src="https://cdn.badlandsranch.com/images/like-reply-text.png" alt="like/reply image" (load)="onImageLoad()">
      }
      @if (slides[currentSlide]?.via) {
        <img class="absolute bottom-[-10px] right-[36px] desktop:right-[76px] z-50" [src]="slides[currentSlide]?.socialIcon" alt="social reaction" (load)="onImageLoad()">
      }

      <!-- Pagination Dots - Add back in if needed -->
      <!-- <div *ngIf="showPagination && pager" class="flex justify-center items-center gap-2 mt-4 px-4">
      <button
        *ngFor="let slide of slides; let i = index"
        class="w-3 h-3 rounded-full border-0 cursor-pointer transition-all duration-300 ease-in-out hover:bg-gray-600 hover:scale-125"
        [class.bg-blue-600]="i === currentSlide"
        [class.scale-130]="i === currentSlide"
        [class.bg-gray-300]="i !== currentSlide"
        (click)="goToSlide(i)"
        [attr.aria-label]="'Go to slide ' + (i + 1)">
      </button>
    </div> -->
  </div>

  <!-- Default slide template - can be overridden -->
  <ng-template #slideTemplate let-slide let-index="index">
    <!-- Social proof format (peopleSayList) -->
    @if (slide.via) {
      <div class="feed_content px-4 relative desktop:px-14">
        <img class="upsell-slider__image mx-auto desktop:absolute z-50" [src]="slide.image" [alt]="slide.alt || 'Social proof image'" (load)="onImageLoad()">
        <div class="feed_content__right relative p-5 bg-white rounded-3xl desktop:ml-28">
          <div class="top_header mb-1" [innerHTML]="'<b>' + slide.title + '</b> <i class=&quot;text-base&quot;>' + slide.via + '</i>'"></div>
          <div class="bottom_content" [innerHTML]="slide.content"></div>
          <div class="footer_container relative">
            <!-- Footer content placeholder -->
          </div>
        </div>
      </div>
    }

    <!-- Standard slide format -->
    @if (!slide.via) {
      <div class="w-full h-full flex flex-col items-center justify-center text-center">
        @if (slide.image) {
          <img [src]="slide.image" [alt]="slide.alt || 'Slide ' + (index + 1)" class="max-w-full h-auto object-cover" (load)="onImageLoad()">
        }
        @if (slide.title) {
          <div class="text-2xl md:text-3xl font-bold mt-4 mb-2 text-gray-800">{{ slide.title }}</div>
        }
        @if (slide.content) {
          <div class="text-base md:text-lg text-gray-600 leading-relaxed px-4">{{ slide.content }}</div>
        }
      </div>
    }
  </ng-template>
</div>
</div>

